<template>
  <div class="send-info">
    <b-modal id="signedContract" centered size="md" no-close-on-backdrop>
      <template #modal-header>
        <div class="send-contract-info text-center">
          <h4>Signed Contract List</h4>
          <b-button variant="close-btn" class='btn-container' @click="closeModal">
            <i class="fas fa-times" />
          </b-button>
        </div>
      </template>
      <b-container>
        <div class="sendInfo-form">
          <div>
            <table v-if="groupedContracts.length > 0">
              <thead>
                <tr>
                  <th>Contract Type</th>
                  <th>Contract Name</th>
                  <th>Level</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(contract, typeIndex) in groupedContracts">
                  <tr :key="`contract-${typeIndex}-row`">
                    <td :rowspan="contract.data.length">
                      {{ contract.contract_display_name }}
                    </td>
                    <td>{{ contract.data[0].contract_item_display_name }}</td>
                    <td>{{ contract.data[0].contract_level }}</td>
                  </tr>
                  <tr
                    v-for="(item, itemIndex) in contract.data.slice(1)"
                    :key="`contract-${typeIndex}-item-${itemIndex}`"
                  >
                    <td>{{ item.contract_item_display_name }}</td>
                    <td>{{ item.contract_level }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div v-else>No contracts available.</div>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "SignedContractModal",

  props: {
    signedContractData: {
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$bvModal.hide("signedContract");
      this.$emit("onClosedModal");
    },
  },
  computed: {
    groupedContracts() {
      if (!this.signedContractData) {
        return [];
      }

      const contracts = this.signedContractData;
      return contracts.reduce((acc, contract) => {
        const existing = acc.find(
          (c) => c.contract_display_name === contract.contract_display_name
        );
        if (existing) {
          existing.data = existing.data.concat(contract.data);
        } else {
          acc.push({ ...contract });
        }
        return acc;
      }, []);
    },
  },
};
</script>
<style scoped>
.table-container {
  max-height: 70%;
  overflow-y: auto;
}

.send-contract-info .btn-container  {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
